import type { PhoneNumber } from "@eckersdorf/api"

export function normalizePolishPhoneNumber(input: string): PhoneNumber | null {
  if (input.trim() === "") {
    return null
  }

  const compact = input.replace(/[\s()-]/g, "")
  const local = compact.startsWith("+48")
    ? compact.slice(3)
    : compact.startsWith("0048")
      ? compact.slice(4)
      : compact

  if (!/^\d{9}$/.test(local)) {
    throw new Error("Podaj 9-cyfrowy polski numer telefonu")
  }

  return local as PhoneNumber
}
